import { useEffect, useEffectEvent, useMemo, useState } from "react"
import { useChatClient } from "@/modules/chat/stores/useChatStore"

export const useChatUnreadCount = () => {
  const chatClient = useChatClient()
  const [unreadCount, setUnreadCount] = useState<number | undefined>(undefined)

  const setInitialUnreadCount = useEffectEvent((initialCount: number) => {
    setUnreadCount(initialCount)
  })

  useEffect(() => {
    const initialCount =
      chatClient.user && "total_unread_count" in chatClient.user ? chatClient.user.total_unread_count : undefined
    if (initialCount !== undefined) {
      setInitialUnreadCount(initialCount)
    }

    const unsubscribe = chatClient.on((e) => {
      const unreadMessages = e.total_unread_count ?? e.me?.total_unread_count
      if (unreadMessages !== undefined) {
        setUnreadCount(unreadMessages)
      }
    }).unsubscribe

    return () => {
      unsubscribe()
    }
  }, [chatClient])

  const hasUnread = useMemo(() => {
    return typeof unreadCount === "number" && unreadCount > 0
  }, [unreadCount])

  return { unreadCount, hasUnread }
}
